module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-table-panel background"
  }, [(_vm.selectedClient) ? _c('div', {
    staticClass: "dialog-table-panel"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table",
    staticStyle: {
      "overflow-y": "unset"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center w40"
  }, [_vm._v(_vm._s(_vm.lang.S0170))]), _vm._v(" "), _c('th', {
    staticClass: "text-center w60"
  }, [_vm._v(_vm._s(_vm.lang.S0171))])])]), _vm._v(" "), _c('tbody', {
    staticClass: "main-table-scrollbar client-policies-table"
  }, _vm._l((_vm.customPropertyValuePairs), function(property, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "td-cb-policies w40 moreheadroom"
    }, [_c('a', {
      staticClass: "table-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          return _vm.togglePermitted(property)
        }
      }
    }, [_vm._v(_vm._s(property.LocationPropertyName))])]), _vm._v(" "), _c('td', {
      staticClass: "w60"
    }, [_c('select2', {
      staticClass: "form-control",
      attrs: {
        "id": ("items-select-" + index),
        "multiple": true,
        "closeOnSelect": false,
        "placeholder": _vm.lang.CM2001,
        "allowClear": true,
        "afterChange": function (data) { return _vm.updateChangedValue(data, property); }
      },
      model: {
        value: (property.SelectedItems),
        callback: function($$v) {
          _vm.$set(property, "SelectedItems", $$v)
        },
        expression: "property.SelectedItems"
      }
    }, _vm._l((property.LocationPropertyValues), function(value, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": value
        }
      }, [_vm._v("\n                  " + _vm._s(value) + "\n                ")])
    }), 0)], 1)])
  }), 0)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03557008","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserMgmt/CustomPropertiesPoliciesControl.vue
// module id = 597
// module chunks = 1 2